import React from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

/** Set `localStorage.xmas = '1'` to see the hat on any day. */
const XMAS_OVERRIDE_KEY = 'xmas'

const hasOverride = () => {
  try {
    return localStorage.getItem(XMAS_OVERRIDE_KEY) === '1'
  } catch {
    return false
  }
}

export const isChristmasEve = () => {
  const today = dayjs()
  // Months are zero-based, so 11 is December
  return (today.month() === 11 && today.date() === 24) || hasOverride()
}

const Svg = styled.svg`
  position: absolute;
  top: -7px;
  left: 0;
  width: 20px;
  height: 17px;
  transform: rotate(-20deg);
  pointer-events: none;
`

/** Small Santa hat to sit on the corner of the logo mark. */
const SantaHat: React.FC = () => (
  <Svg viewBox="0 0 24 20" aria-hidden>
    <path d="M3 15 C5 8 10 3 16 3 C19 3 21 5 21 8 L19 15 Z" fill="#d42426" />
    <rect x="1" y="14" width="21" height="5" rx="2.5" fill="#fff" stroke="#bcbcbc" strokeWidth="0.5" />
    <circle cx="21" cy="8" r="2.5" fill="#fff" stroke="#bcbcbc" strokeWidth="0.5" />
  </Svg>
)

export default SantaHat
